import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LabelAllergenOptionsDisplay, LabelStudentIdDisplayOptionsText } from 'Constants/Constants';
import { AppState, LabelAllergenOptions, LabelStudentIdDisplayOptions, OrderingRules } from 'Interfaces/Interfaces';
import Card from 'Components/Card/Card';
import * as CommonStateActions from 'State/actions';
import * as CommonStateSelectors from 'State/selectors';
import LabelRulesSidebar from '../Sidebars/LabelRulesSidebar';
import { SidebarLocations } from 'Constants/Enums';

export const RuleLabels: FC<{ orderingRules: OrderingRules }> = ({ orderingRules }) => {
  const sidebarOpen = useSelector((state: AppState) =>
    CommonStateSelectors.getSidebarOpen(state, SidebarLocations.LABEL_RULES_SIDE_BAR),
  );
  const dispatch = useDispatch();

  const setSidebarOpen = (isOpen: boolean) => {
    dispatch(CommonStateActions.setSidebarOpen(isOpen, SidebarLocations.LABEL_RULES_SIDE_BAR));
  };

  const labelsAllergenDisplay = orderingRules?.labelsAllergensDisplayType || LabelAllergenOptions.None;
  const labelStudentIdDisplayType = orderingRules?.labelStudentIdDisplayType ?? LabelStudentIdDisplayOptions.Show;

  return (
    <>
      <Card
        title="Labels"
        description="Configure Labels"
        onEditClick={() => setSidebarOpen(true)}
        editAriaLabel="Edit Label Rules"
      >
        <div className="ordering-rules__rules">
          <div className="ordering-rules__setting">
            <h6 className="linq-card__h6">Allergens</h6>
            <div className="setting-value" data-test-id={'allergensLbl'}>
              {LabelAllergenOptionsDisplay[labelsAllergenDisplay]}
            </div>
          </div>
          <div className="ordering-rules__setting">
            <h6 className="linq-card__h6">Student ID</h6>
            <div className="setting-value" data-test-id={'studentIdLbl'}>
              {LabelStudentIdDisplayOptionsText[labelStudentIdDisplayType]}
            </div>
          </div>
        </div>
      </Card>
      <LabelRulesSidebar open={sidebarOpen} setSidebarOpen={setSidebarOpen} orderingRules={orderingRules} />
    </>
  );
};
